import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f687885"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "products-summary" }
const _hoisted_2 = {
  colspan: "2",
  style: {"width":"20%"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-en" }, "Marks and Notes", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "唛头", -1))
const _hoisted_5 = {
  colspan: "2",
  style: {"width":"20%"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-en" }, "Number and Kind of Packages", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "装运包装与数量", -1))
const _hoisted_8 = {
  colspan: "2",
  style: {"width":"20%"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-en" }, "Description of Goods", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "品名", -1))
const _hoisted_11 = {
  colspan: "2",
  style: {"width":"20%"}
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-en" }, "Goods Weight（KGS）", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "毛重（公斤）", -1))
const _hoisted_14 = {
  colspan: "2",
  style: {"width":"20%"}
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-en" }, "Measurement（CBM）", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "尺码（立方米）", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createElementBlock("tr", _hoisted_1, [
    _createElementVNode("td", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode(_component_el_form_item, {
        class: "marks-notes",
        prop: "MarksNotes",
        "label-width": "0px"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.form.Data.MarksNotes ?? "暂无数据"), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("td", _hoisted_5, [
      _hoisted_6,
      _hoisted_7,
      _createVNode(_component_el_form_item, {
        class: "packages-number",
        prop: "PackagesNumber",
        "label-width": "0px"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.form.Data.PackagesNumber ?? "暂无数据"), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        class: "packages-kind",
        prop: "PackagesKind",
        "label-width": "0px"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.form.Data.PackagesKind ?? "暂无数据"), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        class: "packages-number-kind",
        prop: "PackagesNumberKind",
        "label-width": "0px"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.form.Data.PackagesNumberKind ?? "暂无数据"), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("td", _hoisted_8, [
      _hoisted_9,
      _hoisted_10,
      _createVNode(_component_el_form_item, {
        class: "goods-description",
        prop: "GoodsDescription",
        "label-width": "0px"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.form.Data.GoodsDescription ?? "暂无数据"), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        class: "goods-description-remark",
        prop: "GoodsDescriptionRemark",
        "label-width": "0px"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.form.Data.GoodsDescriptionRemark ?? "暂无数据"), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("td", _hoisted_11, [
      _hoisted_12,
      _hoisted_13,
      _createVNode(_component_el_form_item, {
        prop: "GrossWeight",
        "label-width": "0px"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.form.Data.GrossWeight ?? "暂无数据"), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("td", _hoisted_14, [
      _hoisted_15,
      _hoisted_16,
      _createVNode(_component_el_form_item, {
        prop: "Volume",
        "label-width": "0px"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.form.Data.Volume ?? "暂无数据"), 1)
        ]),
        _: 1
      })
    ])
  ]))
}